<template>
    <div class="home-introduct">
        <div class="container-list-banner">
            <div v-if="isLoadingBanner" class="d-flex justify-content-center container-loader">
                <flower-spinner class="loading-component" :animation-duration="2000" :size="30" color="#06C755" />
            </div>
            <div class="container-list-banner-inner">
                <ul class="list-banner">
                    <li v-for="(imageBanner, index) in imageBanners" :key="index" class="banner-item">
                        <img :src="imageBanner.banner_image" :alt="'Banner ' + (index + 1)" />
                    </li>
                </ul>
            </div>
        </div>
        <div class="container-course-slide">
            <div v-if="isLoading" class="d-flex justify-content-center container-loader">
                <flower-spinner class="loading-component" :animation-duration="2000" :size="30" color="#06C755" />
            </div>
            <div v-if="!isLoading && records.length > 0" id="courseCarousel" class="carousel slide"
                data-bs-ride="carousel">
                <div class="carousel-inner">
                    <div v-for="(chunk, index) in groupedRecords" :key="index" class="carousel-item"
                        :class="{ active: index === 0 }">
                        <div class="d-flex justify-content-center">
                            <div v-for="course in chunk" :key="course.id" class="course-card" style="width: 30%;">
                                <div @click="gotoCourse(course)" class="course-card-inner">
                                    <div class="course-cover"><img :src="course.course_image" class="d-block"
                                            :alt="course.course_name" />
                                    </div>
                                    <div class="course-name">{{ this.$truncatedTitle(course.course_name, 80) }}</div>
                                    <!-- <div class="course-price">{{ this.$formatNumber(course.course_price) }} VNĐ</div>
                                    <div class="author-and-chapter">
                                        <div class="author">
                                            <img :src="require('@/assets/home/avatar-logo.jpg')"
                                                alt=""><span>TECHBIM</span>
                                        </div>
                                        <div class="chapter-lesson">
                                            <i class="fa-solid fa-video"></i> {{ course.total_chapter ?
                                                course.total_chapter : 0 }} phần/{{
                                                course.total_lesson ? course.total_lesson : 0 }} bài
                                        </div>
                                    </div> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <a class="carousel-control-prev" href="#courseCarousel" role="button" data-slide="prev">
                    <span><i class="fa-solid fa-chevron-left"></i></span>
                </a>
                <a class="carousel-control-next" href="#courseCarousel" role="button" data-slide="next">
                    <span><i class="fa-solid fa-chevron-right"></i></span>
                </a>
                <div @click="gotoAllCourses()" class="view-all-courses">
                    Xem tất cả khóa học <i class="fa-solid fa-arrow-right"></i>
                </div>
            </div>
        </div>
        <!-- <div v-if="isLoading" class="d-flex justify-content-center container-loader">
            <flower-spinner class="loading-component" :animation-duration="2000" :size="30" color="#06C755" />
        </div>
        <div class="container-course" v-if="!isLoading">
            <div>
                <div class="title-container">
                    <h1>KHOÁ HỌC NỔI BẬT</h1>
                </div>
                <ul class="ul-course">
                    <li class="course-item" v-for="(record, index) in featured_courses" :key="index"
                        @click="gotoCourse(record)">
                        <img class="img-cover-course"
                            :src="record.course_image ? record.course_image : require('@/assets/home/item-source.jpg')"
                            alt="Course Thumbnail">
                        <div class="content">
                            <p class="chapter-lesson"><i class="fa-solid fa-video"></i> {{ record.total_chapters }}
                                phần/{{ record.total_lessons }} bài </p>
                            <h2 class="h2-name-course">{{ this.$truncatedTitle(record.course_name, 100) }}</h2>
                            <p class="author"><img :src="require('@/assets/home/logo_slim.jpg')" alt=""><span>TECH
                                    BIM</span></p>
                            <h1 class="h1-price"><i class="fa-solid fa-tags"></i> {{
                                this.$formatNumber(record.course_price) }} VNĐ</h1>
                        </div>
                    </li>
                </ul>
            </div>
        </div> -->
        <!-- <div class="home-news">
            <div class="title-container">
                <h1>THÔNG BÁO TỪ QUẢN TRỊ VIÊN</h1>
            </div>
            <div>
                <ul>
                    <HomeNews></HomeNews>
                </ul>
            </div>
        </div> -->
    </div>
</template>
<script>
import UserRequest from '@/restful/UserRequest';
import { FlowerSpinner } from 'epic-spinners';
// import HomeNews from '@/components/home/HomeNews.vue';
export default {
    name: "HomeIntroduct",
    components: {
        FlowerSpinner,
        // HomeNews,
    },
    data() {
        return {
            isLoading: false,
            isLoadingBanner: false,
            imageBanners: [],
            // featured_courses: null,
            big_search: {
                order_by: 'id',
                order_direction: 'desc',
            },
            query: '',
            records: [],
        }
    },
    mounted() {
        document.title = 'Techbim'
        this.$emitEvent('HomeIntroductPage', true);
        this.getImageBanners();
        this.getDataCourses();
    },
    beforeUnmount() { // sự kiện hủy component Home Introduct 
        this.$emitEvent('HomeIntroductPage', false);
    },
    computed: {
        groupedRecords() {
            const chunkSize = 3;
            const result = [];
            for (let i = 0; i < this.records.length; i += chunkSize) {
                result.push(this.records.slice(i, i + chunkSize));
            }
            return result;
        },
    },
    methods: {
        gotoCourse: function (record) {
            this.$router.push({ name: 'HomeCourseDetail', params: { slug_name_course: record.course_slug + '-id-record-' + record.id } });
        },
        gotoAllCourses: function () {
            this.$router.push({ name: 'HomeCourse' });
        },
        // getDataRecords: async function () {
        //     this.isLoading = true;
        //     try {
        //         const { data } = await UserRequest.get('home/featured-course')
        //         this.featured_courses = data;
        //         this.isLoading = false;
        //     }
        //     catch (error) {
        //         if (error.messages) this.$emitEvent('eventError', error.messages[0]);
        //         this.isLoading = false;
        //     }
        // },
        getDataCourses: async function () {
            this.isLoading = true;
            this.query = `?order_by=${this.big_search.order_by}&order_direction=${this.big_search.order_direction}`;
            try {
                const { data } = await UserRequest.get('user/course/get-all' + this.query)
                this.records = data;
                this.isLoading = false;
            }
            catch (error) {
                if (error.messages) this.$emitEvent('eventError', error.messages[0]);
                this.isLoading = false;
            }
        },
        getImageBanners: async function () {
            this.isLoadingBanner = true;
            try {
                const { data } = await UserRequest.get('home/banner')
                this.imageBanners = data;
                this.isLoadingBanner = false;
            }
            catch (error) {
                if (error.messages) this.$emitEvent('eventError', error.messages[0]);
                this.isLoadingBanner = false;
            }
        },
    }
}
</script>
<style scoped src="./homeintroduct-responsive.css"></style>
<style scoped>
.home-introduct {
    /* margin-top: 10px; */
    /* padding: 0px 10%; */
    background-color: white;
}

.container-course-slide {
    padding: 10px 0px;
    /* margin: 10px 0px; */
}

/*  */
.container-banner {
    margin-bottom: 60px;
}

/*  */
.title-container {
    margin: 20px 0px;
    font-size: 42px;
    line-height: 42px;
    text-align: center;
    font-family: "Quicksand", Helvetica, Arial, sans-serif;
    font-weight: 400;
}

/* course li */
/*
.container-course {
    display: flex;
    justify-content: center;
    padding: 5% 20%;
    background-image: linear-gradient(180deg, #D4EAF7 0%, #ffffff 100%);
}

.ul-course {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
    list-style-type: none;
}

li.course-item {
    cursor: pointer;
    box-sizing: border-box;
    list-style: none;
    display: flex;
    border: 1px solid #ddd;
    background-color: white;
    border-radius: 10px;
    margin: 10px;
    padding: 10px;
    transition: all 0.5s ease;
    scale: 1;
}

li.course-item:hover {
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    transition: all 0.5s ease;
    scale: 1.1;
}

li.course-item>img {
    width: 200px;
    height: 200px;
    min-width: 200px;
    min-height: 200px;
    object-fit: cover;
    border-radius: 10px;
    margin-right: 20px;
}

li.course-item .content {
    display: flex;
    flex-direction: column;
}

li.course-item .content h2 {
    font-size: 18px;
    margin: 0 0 10px;
}

li.course-item .content p {
    font-size: 14px;
    color: #666;
}

.content .author {
    display: flex;
    margin-top: 6px;
    margin-bottom: 10px;
}

.content .author img {
    max-width: 20px;
    border-radius: 100px;
    margin-right: 6px;
}

.content h1 {
    font-size: 20px;
    font-weight: 500;
}
*/
/* course li */

/* course slide */
.carousel.slide {
    height: max-content;
    background-color: white;
}

.carousel.slide a:hover span {
    color: var(--user-color);
}

.view-all-courses {
    color: silver;
    cursor: pointer;
    margin-top: 10px;
    text-align: center;
    font-weight: bold;
    text-transform: uppercase;
    transition: all 0.5s ease;
}

.view-all-courses:hover {
    color: var(--user-color);
    transition: all 0.5s ease;
}

.view-all-courses i {
    margin-left: 5px;
}


/* course-card */
.carousel-item {
    background-color: white;
    height: max-content;
}

.course-card {
    background-color: white;
    padding: 5px;
    transition: all 0.5s ease;
}

.course-card:hover {
    transition: all 0.5s ease;
    scale: 1.05;
}


.course-card-inner {
    height: fit-content;
    /* height: 339px; */
    /* padding-bottom: 10px; */
    /* border: 1px solid silver; */
    cursor: pointer;
}

.course-card .course-name {
    text-transform: uppercase;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;

    display: flex;
    align-content: center;
    align-items: center;
    justify-content: center;
    text-align: center;
    font-weight: bold;
    /* margin-top: 6px; */
    padding: 10px 10px;
    background-color: #232F3E;
    color: white;
}

.course-card .course-price {
    text-align: center;
    text-decoration: underline;
    font-size: 22px;
    font-weight: bold;
    color: #06C755;
}

.author-and-chapter {
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;
    margin-top: 10px;
    font-weight: bold;
}



.course-cover {
    width: 100%;
    /* height: 200px; */
    /* overflow: hidden; */
}

.course-card .course-cover img:hover {
    /* transform: scale(1.2); */
    /* transition: all 0.5s ease; */
}


.course-card .author {
    display: flex;
    align-content: center;
    align-items: center;
    margin-right: 10px;
}

.course-card .author img {
    max-width: 30px;
    border-radius: 100%;
    margin-right: 6px;
}

.chapter-lesson {
    margin-left: 10px;
    display: flex;
    align-content: center;
    align-items: center;
}

.chapter-lesson i {
    margin-right: 5px;
}


/* course slide */


/* .home-news {
    background-image: linear-gradient(180deg, #D4EAF7 0%, #ffffff 100%);
    padding-top: 120px;
    padding-bottom: 120px;
} */

/* .container-list-banner  */
.container-list-banner {
    width: 100%;
}

.container-list-banner .banner-item {
    margin: 10px 0px;
}

.container-list-banner .banner-item img {
    width: 100%;
    /* height: 450px; */
    /* object-fit: fill; */
}

/* .container-list-banner  */

/* load */
.loading-component {
    margin: 100px 0px;
}

/* load */

/* feeling */
/* .feeling-student {
    display: flex;
    justify-content: center;
    margin: 0px 5%;
    margin-top: 120px;
}
.ul-feeling {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
}

.li-feeling {
    cursor: pointer;
    padding: 20px;
    margin: 15px;
    border-radius: 6px;
    box-shadow: rgba(147, 170, 191, 0.48) 6px 2px 16px 0px, rgba(255, 255, 255, 0.8) -6px -2px 16px 0px;
    transition: all 0.5s ease;
}
.li-feeling:hover {
    transition: all 0.5s ease;
    scale: 1.02;
    box-shadow: rgba(110, 172, 226, 0.48) 6px 2px 16px 0px, rgba(255, 255, 255, 0.8) -6px -2px 16px 0px;
}

.avatar-student {
    display: flex;
    align-items: center;
}
.avatar-student img {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    object-fit: cover;
    object-position: center;
    margin-right: 10px;
}

.student-name {
    font-weight: bold;
    font-size: 20px;
}

.student-job {
    color: silver;
} */

/* gallery */
/* .container-gallery {
    margin-top: 120px;
    display: flex;
    justify-content: center;
}

.intro-gallery {
    color: #7A7A7A;
    font-size: 14px;
    text-align: center;
    margin-bottom: 30px;
}

.ul-gallery {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 10px;
    list-style-type: none;
}
.ul-gallery li {
    margin-bottom: 20px;
    cursor: pointer;
}
.ul-gallery li img {
    width: 200px;
    border-radius: 6px;
    height: 200px;
    object-fit: cover;
    object-position: center;
} */
</style>